import React from "react";

import { Text } from "@whoosh/design-system/src/components/primitive";

import { EighteenHoleIcon } from "./icons/EighteenHoleIcon";
import { NineHoleIcon } from "./icons/NineHoleIcon";

export * from "./icons/NineHoleIcon";
export * from "./icons/EighteenHoleIcon";
export * from "./icons/HoleCountIcon";

export const GetCourseLayoutIconFromCode = (code: string) => {
  switch (code) {
    case "9":
      return NineHoleIcon;
    case "NINE":
      return NineHoleIcon;
    case "18":
      return EighteenHoleIcon;
    case "EIGHTEEN":
      return EighteenHoleIcon;
    default:
      return () => (
        <Text maxFontSizeMultiplier={2} variant="mainSmallSemiBold">
          {code}
        </Text>
      );
  }
};
